<script setup lang="ts">
const props = defineProps<{
  text: string
  showDelete?: boolean
}>()

const emit = defineEmits<{
  (e: 'delete'): void
}>()

const handleDelete = () => {
  emit('delete')
}
</script>

<template>
  <div class="base-tag sub-md white" :class="{ 'with-delete': props.showDelete }">
    {{ props.text }}
    <img
      v-if="props.showDelete"
      class="svg-20 svg-white cursor-pointer"
      src="@/assets/svgs/close.svg"
      alt="close"
      @click="handleDelete"
    />
  </div>
</template>

<style scoped>
.base-tag {
  width: fit-content;
  background-color: var(--tint-500);
  padding: 5px 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  box-sizing: border-box;
}

.base-tag.with-delete {
  padding: 5px 10px 5px 16px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
